document.addEventListener("DOMContentLoaded", function () {
  loadLoader();
});

document.addEventListener("shopify:section:load", function () {
  loadLoader();
});

function loadLoader() {
  const targetNode = document.querySelector('div[slot="content"].md\\:grid.md\\:grid-cols-2');

  const quantityElm = `
    <div class="flex items-center mb-3 md:mb-4" style="justify-content: space-between;">
      <legend class="label label-product-info">Quantity</legend>
    </div>
    <qty-selector class="qty-selector">
      <button type="button" data-dec class="button button-light qty-selector__button">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line shape-rendering="crispEdges" y1="32" x2="64" y2="32" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
        </svg>
      </button>

      <input id="quantity" name="quantity"  type="number" class="hide-input-arrows" min="1" value="1">

      <button type="button" data-inc class="button button-light qty-selector__button">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line shape-rendering="crispEdges" x1="32" y1="0" x2="32" y2="64" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
          <line shape-rendering="crispEdges" y1="32" x2="64" y2="32" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
        </svg>
      </button>
    </qty-selector>
  `;

  if (!targetNode) {
    console.warn('Target element not found: <div slot="content" class="md:grid md:grid-cols-2">');
    return;
  }

  let timeoutId = null;

  const handleMutations = (mutationsList) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      mutationsList.forEach(() => {
        const quickAddModal = document.querySelector("quick-add-modal");

        if (quickAddModal) {
          const productForm = quickAddModal.querySelector("product-form #Product-Form-product-quick-add-modal");

          if (productForm && !productForm.querySelector(".qty-selector")) {
            productForm.insertAdjacentHTML("afterbegin", quantityElm);
          }
        }
      });
    }, 50);
  };

  const observerConfig = {
    attributes: true,
    subtree: true,
  };

  const observer = new MutationObserver(handleMutations);
  observer.observe(targetNode, observerConfig);

  console.log('MutationObserver is watching <div slot="content" class="md:grid md:grid-cols-2"> for changes.');
}
